import { faGauge } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { AiOutlineComment } from "react-icons/ai";
import { Link } from "react-router-dom";

function SubAdmin() {
  const [acc20, setAcc20] = useState(false);
  const [acc21, setAcc21] = useState(false);

  return (
    <div className="si09">
      <div className="lo-ad">
        <figure
          style={{
            width: "100%",
            height: "100px",
            padding: "10px 11px",
            textAlign: "center",
          }}
        >
          <img src="./logo.jpeg" alt="adminlogo" className="img-fluid" />
        </figure>
      </div>
      <ul>
        <Link to="/subadmin">
          <li
            className={`a-ele ${acc20 ? "active-0 " : ""}`}
            onClick={() => {
              setAcc20(true);
              setAcc21(false);
            }}
          >
            <AiOutlineComment className="menu-icon" /> ADD SUB ADMIN
            <i className="fa fa-angle-right menu-arrow"></i>
          </li>
        </Link>
        
        <Link to="/adminleadgeneration">
          <li className="a-ele">
            <AiOutlineComment className="menu-icon" /> ADMIN LEAD
            <i className="fa fa-angle-right menu-arrow"></i>
          </li>
        </Link>
        
        <Link to="/adminleadmanagement">
          <li className="a-ele">
            <AiOutlineComment className="menu-icon" /> LEAD MANAGEMENT
            <i className="fa fa-angle-right menu-arrow"></i>
          </li>
        </Link>
        
        <Link to="/subadmintrackdetails">
          <li
            className={`a-ele ${acc21 ? "active-0 " : ""}`}
            onClick={() => {
              setAcc21(true);
              setAcc20(false);
            }}
          >
            <AiOutlineComment className="menu-icon" /> SUB-ADMIN TRACK DETAILS
            <i className="fa fa-angle-right menu-arrow"></i>
          </li>
        </Link>
      </ul>
    </div>
  );
}

export default SubAdmin;
